import * as classnames from 'classnames';
import { darken } from 'polished';
import { deprecatedCss, ShelfIcon } from '../../common-elements';
import styled, { css
/* ResolvedThemeInterface */
} from '../../styled-components';
export const OperationBadge = styled.span.attrs((props: {
  type: string;
}) => ({
  className: `operation-type ${props.type}`
})).withConfig({
  displayName: "styledelements__OperationBadge",
  componentId: "sc-1inzg2l-0"
})(["width:37px;display:inline-block;background-color:#333;background-repeat:no-repeat;font-size:10px;color:white;text-transform:uppercase;text-align:center;font-weight:400;line-height:1.675em;text-decoration:none;margin:0 0.5em 0 0;display:inline;padding:0.25em 0.675em;border-radius:8px 8px 8px 2px;&.get{background-color:", ";}&.post{background-color:", ";}&.put{background-color:", ";}&.options{background-color:", ";}&.patch{background-color:", ";}&.delete{background-color:", ";}&.basic{background-color:", ";}&.link{background-color:", ";}&.head{background-color:", ";}"], props => props.theme.colors.http.get, props => props.theme.colors.http.post, props => props.theme.colors.http.put, props => props.theme.colors.http.options, props => props.theme.colors.http.patch, props => props.theme.colors.http.delete, props => props.theme.colors.http.basic, props => props.theme.colors.http.link, props => props.theme.colors.http.head);
export const MenuItemUl = styled.ul.withConfig({
  displayName: "styledelements__MenuItemUl",
  componentId: "sc-1inzg2l-1"
})(["margin:0;padding:0;overflow:hidden;max-height:1800px;transition:max-height 0.25s ease-in;& &{font-size:1em;}", ";"], props => props.expanded ? '' : 'max-height: 0;transition: max-height 0.25s ease-out;');
export const MenuItemLi = styled.li.withConfig({
  displayName: "styledelements__MenuItemLi",
  componentId: "sc-1inzg2l-2"
})(["list-style:none inside none;overflow:hidden;text-overflow:ellipsis;padding:0;", ";"], props => props.depth === 0 ? 'margin-top: 15px' : '');
export const menuItemDepth = {
  0: css(["opacity:0.7;text-transform:", ";font-size:0.8em;padding-bottom:0;cursor:default;color:", ";"], ({
    theme
  }) => theme.sidebar.groupItems.textTransform, props => props.theme.sidebar.textColor),
  1: css(["font-size:1em;text-transform:", ";&:hover{color:", ";}"], ({
    theme
  }) => theme.sidebar.level1Items.textTransform, props => props.theme.sidebar.activeTextColor),
  2: css(["color:", ";"], props => props.theme.sidebar.textColor)
};
export interface MenuItemLabelType {
  depth: number;
  active: boolean;
  deprecated?: boolean;
  type?: string;
}
export const MenuItemLabel = styled.label.attrs((props: MenuItemLabelType) => ({
  role: 'menuitem',
  className: classnames('-depth' + props.depth, {
    active: props.active
  })
})).withConfig({
  displayName: "styledelements__MenuItemLabel",
  componentId: "sc-1inzg2l-3"
})(["cursor:pointer;font-weight:", ";color:", ";margin:0;padding:0.375em 0 0.375em 1.5em;line-height:1.25em;display:block;", " display:flex;justify-content:space-between;font-family:", ";", ";background-color:transparent;", ";&.has-subnav{padding:0.375em 0 0.375em .25em;}&:hover{[class*=MenuItemTitle]{color:", ";text-decoration:underline;}[class*=OperationBadge]{text-decoration:none;}}&.-depth1{font-size:1em;}&.-depth2{padding:0.375em 0 0.375em 2.5em;}&.-depth3{padding:0.5em 0 0.375em 5em;}&.active{color:#231F20;}", "{height:", ";width:", ";polygon{fill:", ";}}"], props => props.active ? '400' : '300', props => props.active ? props.theme.sidebar.activeTextColor : props.theme.sidebar.textColor, ({
  depth,
  type,
  theme
}) => type === 'section' && depth > 1 && 'padding-left: ' + theme.spacing.unit * 8 + 'px;' || '', props => props.theme.typography.headings.fontFamily, props => menuItemDepth[props.depth], props => props.deprecated && deprecatedCss || '', props => props.theme.typography.links.color, ShelfIcon, ({
  theme
}) => theme.sidebar.arrow.size, ({
  theme
}) => theme.sidebar.arrow.size, ({
  theme
}) => theme.sidebar.arrow.color);
export const MenuItemTitle = styled.span.withConfig({
  displayName: "styledelements__MenuItemTitle",
  componentId: "sc-1inzg2l-4"
})(["display:inline;vertical-align:middle;width:", ";overflow:hidden;text-overflow:ellipsis;padding-left:3px;"], props => props.width ? props.width : 'auto');
export const RedocAttribution = styled.div.withConfig({
  displayName: "styledelements__RedocAttribution",
  componentId: "sc-1inzg2l-5"
})(["", ";"], ({
  theme
}) => `
  font-size: 0.8em;
  margin-top: ${theme.spacing.unit * 2}px;
  padding: 0 ${theme.spacing.unit * 4}px;
  text-align: left;

  opacity: 0.7;

  a,
  a:visited,
  a:hover {
    color: ${theme.sidebar.textColor} !important;
    border-top: 1px solid ${darken(0.1, theme.sidebar.backgroundColor)};
    padding: ${theme.spacing.unit}px 0;
    display: block;
  }
`);